import { Variants } from "framer-motion";

export const CountryVariants: Variants = {
    'light': {
        backgroundColor: "hsl(0, 0, 100%)",
        boxShadow: '0 0 10px -2px #ccc'
    },
    'dark': {
        backgroundColor: 'hsl(209, 23%, 22%)',

    }
}

export const CountryInfoVariants: Variants = {
    'light': {
        color: "rgb(114, 114, 114)"
    },
    'dark': {
        color: '#ccc'
    }
}